import { hasWindow } from "./dom";
var g = {};

if (hasWindow()) {
  if (window.idpcGlobal) {
    g = window.idpcGlobal;
  } else {
    window.idpcGlobal = g;
  }
}

export var idpcState = function idpcState() {
  return g;
};
export var reset = function reset() {
  return Object.getOwnPropertyNames(g).forEach(function (p) {
    return delete g[p];
  });
};